import React, { Component } from "react";
import { path } from "ramda";
import { Row, Col, Card , Tooltip, Icon } from "antd";
import styled, { withTheme, css } from "styled-components";
import { ThemeHelper } from "../../hoc/with/withThemeProvider";
import I18n, { fromSyntax } from "../../i18n";
import Metrics from "../../theme/Metrics";
import Color, { DataVisualizeKeys } from "../../theme/Colors";
import { isFunction } from "../../util";
import { SimpleText, SingleLine } from "../text/OText";
import { isAlive, ArrayUtil, ColorUtil } from "../../util/";
import EmptyModal from "../modal/EmptyModal";
import { CounselingSupportGraph } from "../../constants/supportGraph";
import i18next from "../../i18n";
import { EmptyDataBar } from "./ProgressReturningBar";

const EmptyBar = styled.div`
    min-height:50px;
`;

const HorizontalBar = styled.div`
  border-radius: ${Metrics.progressBar.horizontalBar.borderRadius}px;
  height: ${Metrics.progressBar.horizontalBar.height}px;
  background: ${props => props.color};
  width: 100%;
`;


const TopicName = styled.span`
  font-size: ${Metrics.progressBar.TopicName.fontSize}px;
  text-align: ${Metrics.progressBar.TopicName.textAlign};
  color: ${Metrics.progressBar.TopicName.color};
`;

const Title = styled.p`
  font-size: ${Metrics.fontSize.header}px;
  font-weight: bold;
`;

const StackBar = styled.span`
  height: 100%;
  font-weight: ${Metrics.progressBar.textInProgressBar.fontWeight};
  color: ${Metrics.progressBar.textInProgressBar.color};
  display: inline-block;
  box-sizing: border-box;
  text-align: ${props => (props.position ? props.position : "left")};
  float: ${props => (props.position ? props.position : "left")};
  border-radius: 0px 6px 6px 0px;
  width: ${props => props.width}%;
  background: ${props => props.background};
  line-height:28px;
`;

// padding-top: 5px;
//   padding-bottom: 5px;
//   ${props=>props.right ? `
//     padding-left:  0px;
//     padding-right: 8px;
//   ` : ""}
//   ${props=>props.left ? `
//     padding-left:  8px;
//     padding-right: 0px;
//   ` : ""}

const IconLegend = styled(Icon) `
    font-size: 24px !important;
    color: ${props => (props.color ? props.color : "#000000")};
`;
const TextLegend = styled.span`
    margin-right: ${props => (props.marginRight ? props.marginRight : 0)}px;
    font-size : 12px;
`;
const Box = props => {
	const { colors, value, onClick } = props; 
	const { type, good = 0, bad = 0, title = "BOBO" } = value;
	const sum = Math.max(1, good+bad);
	return <div style={{ marginBottom: 5 }}>
		<TopicName>{title}</TopicName>
		{(good === 0) && (bad === 0) ? <EmptyDataBar /> :
			<HorizontalBar color={colors["good"]}>
				{good ? <Tooltip title={`${I18n.t("good")} : ${good} (${(good / sum * 100).toFixed(2)}%)`}>
					<StackBar left onClick={onClick ? () => {
						onClick({ type, value: "good" });
					} : undefined} width={Math.floor(good / sum * 100)}>
						<p style={{paddingLeft:5}}>{good / sum * 100 > 10 ? `${(good / sum * 100).toFixed(2)}%` : ""}</p>
					</StackBar>
				</Tooltip> : ""}
				{bad ? <Tooltip title={`${I18n.t("bad")} : ${bad} (${(bad / sum * 100).toFixed(2)}%)`}>
					<StackBar right onClick={onClick ? () => {
						onClick({ type, value: "bad" });
					} : undefined} background={colors["bad"]} width={Math.ceil(bad / sum * 100)} position="right">
						<p style={{paddingRight:5}}>{bad / sum * 100 > 10 ? `${(bad / sum * 100).toFixed(2)}%` : ""}</p>
					</StackBar>
				</Tooltip> : ""}
			</HorizontalBar>
		}
	</div>;
};



const Legend = props => {
	const { colors } = props;
	return <div style={{ marginBottom: 5 , textAlign:"center" , marginTop: 30 }}>
		<TextLegend marginRight='30'>
			<IconLegend type="like-o" color={colors["good"]} />{I18n.t("good")}
		</TextLegend>
		<TextLegend>
			<IconLegend type="dislike-o" color={colors["bad"]} />{I18n.t("bad")}
		</TextLegend>
	</div>;
};

const HorizontalBarGraph = (props)=>{
	const { isLoadMore = true, style = undefined, value, 
		colorType = DataVisualizeKeys.Primary, 
		theme, isShowLegend = true, onClick,
		height, data = {}
	} = props;
	delete data.provider_feedback;
	const texts = {
		[CounselingSupportGraph.PatientFeedback]:I18n.t("user"),
		[CounselingSupportGraph.ProviderFeedback]:I18n.t("provider"),
		undefined:I18n.t("unassign")
	};
	const mutateDatas = [];
	const keyTopic = Object.keys(data);
	let colors = ColorUtil.generateVisualColorOfSize(theme, colorType, 2);
	colors = {good:colors[0], bad:colors[1]};
	if(ArrayUtil.isAliveArray(keyTopic)){
		keyTopic.forEach((key,i)=>{
			const { good, bad } = data[key];
			mutateDatas[i] = {title:texts[key], type:key, good, bad};
		});
	}
	return <div style={{...style, height, overflowY:"auto"}}>
		{path(["value","title"], value) ? <Title>{value.title}</Title> : undefined}
		{ArrayUtil.isAliveArray(keyTopic) ? (
			mutateDatas.map((Val, index) => (
				<Box
					key={index}
					value={Val}
					colors={colors}
					onClick={onClick}
				/>
			))
		) : (
			<EmptyBar />
		)}
		{isShowLegend?
			<Legend colors={colors}></Legend>
			:""}
	</div>;
};


export default withTheme(HorizontalBarGraph);


// WEBPACK FOOTER //
// ./src/components/chart/ProgressCompareBar.js